// extracted by mini-css-extract-plugin
module.exports = {"main":"PricesPage_main__37ryk","Empty":"PricesPage_Empty__2rV_w","priceLists":"PricesPage_priceLists__1llBu","PricesPage":"PricesPage_PricesPage__Je8qM"};